/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { catchErrorAsJson } from '@fcom/rx';
import { DapiHttpResponse } from '../../dapi-http-response';
import { DapiRequestBuilder } from '../../dapi-request-builder';

import { FinnairAlternativeOfferConfirmationStatus } from '../../models/finnair-alternative-offer-confirmation-status';

export interface DisruptionConfirmStatus$Params {
  orderId: string;
  jobId: string;
  locale?: string;
  hash?: string;
}

export function disruptionConfirmStatus(http: HttpClient, rootUrl: string, params: DisruptionConfirmStatus$Params, context?: HttpContext): Observable<DapiHttpResponse<FinnairAlternativeOfferConfirmationStatus>> {
  const rb = new DapiRequestBuilder(rootUrl, disruptionConfirmStatus.PATH, 'get');

  if (params) {
    rb.path('orderId', params.orderId, {});
    rb.path('jobId', params.jobId, {});
    rb.query('locale', params.locale, {});
    rb.query('hash', params.hash, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as DapiHttpResponse<FinnairAlternativeOfferConfirmationStatus>;
    }),
    catchErrorAsJson()
  );
}

disruptionConfirmStatus.PATH = '/api/order/{orderId}/disruption-rebooking/confirm-alternative/{jobId}';
